const CheckboxGroup = ({ options, name, selectedValues, onChange, error }) => {
  return (
    <div className="registration-form__field">
      <label className="registration-form__label">
        Chương trình đào tạo quan tâm <span className="required">*</span>
      </label>
      <div className="registration-form__checkbox-group">
        {options.map((opt) => (
          <label key={opt}>
            <input
              type="checkbox"
              name={name}
              value={opt}
              checked={selectedValues.includes(opt)}
              onChange={onChange}
            />
            {opt}
          </label>
        ))}
      </div>
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default CheckboxGroup;
